// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__B0jVJ","table":"default_table__sR2+5","table__empty":"default_table__empty__k3oiT"};